// FT-018 STEP-09 + SEC-01 + FT-066: reconnect on region / auth identity change.
//
// Vue 2 Options API mixin (PCON-05), applied on App.vue. URL building now lives in
// main.js cableUrlFn (re-evaluated by the native @rails/actioncable consumer on every
// (re)connect → fresh region + token), so this mixin only TRIGGERS reconnect/disconnect:
//  - region flip: reconnect (urlFn re-reads cable_urls[newRegion] or falls back to the
//    getApiUrl-derived base). FM-06 guard: only on a real flip (skip null↔region).
//  - auth_token change (SEC-01): login (null→token) / re-auth → reconnect WITH the current
//    token (urlFn re-reads localStorage). logout (token→null) → disconnect (unsetCurrentUser
//    already nulled region/api_url/cable_urls + subscriptions but does NOT close the socket).
//
// Behavior note (deliberate, FT-066): the old "no cable_url for newRegion → stay on current
// connection" branch now resolves inside cableUrlFn (it falls back to buildCableUrl(api_url)).
// Token travels as ?token= query-param. SECURITY: never log the tokenized URL.

import { reconnect, disconnect } from "@/cable";

export default {
  watch: {
    "$store.state.region"(newVal, oldVal) {
      // FM-06 guard: skip initial null→region and logout region→null.
      if (newVal === oldVal || newVal == null || oldVal == null) return;
      reconnect(); // urlFn re-reads region + token
    },

    // SEC-01: re-establish the connection when auth identity changes.
    "$store.state.auth_token"(newVal, oldVal) {
      if (newVal === oldVal) return;
      if (!newVal) { disconnect(); return; } // logout: drop the authenticated socket
      reconnect();                           // login / re-auth: reconnect carrying current token
    },
  },
};
